// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  twinElevationOffsetM: __t.option(__t.f64()),
  sceneYawOffsetDeg: __t.option(__t.f64()),
  autoTeleportPlayerToProjectOrigin: __t.option(__t.bool()),
  clampDynamicTwinsToTerrain: __t.option(__t.bool()),
  clampStaticTwinsToTerrain: __t.option(__t.bool()),
};
